import classNames from 'classnames';
import React from 'react';
import styles from './TextareaControl.module.scss';

export interface TextareaControlProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: string;
  label?: React.ReactNode;
}

const TextareaControl = ({
  error,
  label,
  ...inputProps
}: TextareaControlProps) => (
  <label>
    {!!label && <div className={styles.label}>{label}</div>}
    <textarea
      className={classNames(styles.input, { [styles.error]: error })}
      {...inputProps}
    />
  </label>
);

export default TextareaControl;
